export default "__VITE_ASSET__CRXd3$h3__";